import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import CheckboxGroup from '../../molecules/CheckboxGroup'
import Card from '../../atoms/Card'

const StyledCard = styled(Card)`
  height: 360px;
`

const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
`

export default class ResearchSubClassCard extends React.PureComponent {
  render() {
    return (
      <FormattedMessage
        id="survey.subclass.title"
      >
        {(text) => (
          <StyledCard title={text}>
            <StyledCheckboxGroup
              { ...this.props }
            />
          </StyledCard>
        )}
      </FormattedMessage>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchSubClassCard/ResearchSubClassCard.js